import { ResetGameCommand } from "ags/commands/reset-game-fatal-error-command";
import { AGSRecordBuilder } from "ags/integration/builders/records/abstract-ags-record-builder";
import { AGSFeatureTypes, AGSPickSchema, AGSWin } from "ags/integration/schema/ags-spin-response-schema";
import Gameplay from "slotworks/model/gameplay/gameplay";
import PickMatchRecord from "slotworks/model/gameplay/records/pick-match-record";
import PickRequestPayload from "slotworks/model/gameplay/requests/pick-request-payload";
import { RecordBuilder } from "slotworks/server/builders/record-builder";
import { isUndefined } from "util";
import { AGSSpinPublicStateSchema } from "../../schema/ags-spin-response-schema";

export class PickRecordBuilder extends AGSRecordBuilder implements RecordBuilder {

    public id: string = "AGSPickRecordBuilder";

    public filter(request: any, response: any): boolean {
        return request instanceof PickRequestPayload;
    }

    public build(gameplay: Gameplay, request: any, response: any) {

        const rootData = this.getRootAGSRecord(response);

        const platform = rootData.platform;
        if (platform.responsibleGamingEvent) {
            // SG requirement - fatal error
            ResetGameCommand();
            return [];
        }

        super.build(gameplay, request, response);

        const latestPick = this.getLatestAGSSpin(rootData.publicState) as AGSPickSchema;
        let spinComplete = latestPick.complete;

        if (this.freespinsNotStarted(rootData.publicState)) {
            spinComplete = false;
        }

        const record = this.buildRecord(latestPick, spinComplete);

        return [record];
    }

    public buildRecord(pick: AGSPickSchema, spinComplete: boolean): PickMatchRecord {
        const record = new PickMatchRecord();
        record.index = pick.index;
        record.value = pick.value;
        record.isPrize = pick.complete;
        record.lastChild = isUndefined(spinComplete) ? pick.complete : spinComplete;
        record.cashWon = pick.cashWon || 0;
        record.complete = pick.complete;

        return record;
    }

    private freespinsNotStarted(rootState: AGSSpinPublicStateSchema) {
        const spin = rootState.spin;

        let freespinsTriggered = false;
        let freespinsStarted = false;
        if (spin.wins.length > 0) {
            spin.wins.forEach((win: AGSWin) => {
                if (win.freeSpinsAmount > 0 || win.featureType === AGSFeatureTypes.FREESPINS_WIN) {
                    freespinsTriggered = true;
                }
            });
        }

        if (freespinsTriggered) {
            for (const childFeature of spin.childFeature) {
                if (childFeature.type === "freeSpin") {
                    freespinsStarted = true;
                }
            }
        }

        return freespinsTriggered && !freespinsStarted;
    }
}

export default new PickRecordBuilder();
